export default {
    IMAGE: 'IMAGE',
    PARAGRAPH: 'PARAGRAPH',
    TABLE: 'TABLE',
    BUTTON: 'BUTTON',
    SPACER: 'SPACER',
    SOCIAL: 'SOCIAL',
    SURVEY: 'SURVEY',
    VIDEO: 'VIDEO'
}
